/* eslint-disable max-len */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Modal from 'react-modal';
import cn from 'classnames';
import renderIf from 'render-if';
import PropTypes from 'prop-types';
import styles from './Tutorial.scss';// to import local scss fle
import { startTrial } from '../../../common/services/saProfile.service';
import FullScreenLoader from '../../FullScreenLoader';


class Tutorials extends Component {
  static propTypes = {
    showCounterScreen: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired,
    showCountOne: PropTypes.bool.isRequired,
    onTrial: PropTypes.bool.isRequired,
    subscribed: PropTypes.bool.isRequired,
    showTrialButton: PropTypes.bool.isRequired,
    saProfileID: PropTypes.string.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
    };
  }
  onCloseModal = () => {
    // console.log('id; ', this.props.saProfileID);
    this.props.showCounterScreen();
  }

  setLoader = () => {
    this.setState({
      isLoading: !this.isLoading,
    });
  }
  render() {
    const { isLoading } = this.state;
    const modalStyle = {
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        zIndex: 1,
      },
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        minHeight: '300px',
        paddingTop: '20px',
        paddingLeft: '0px',
        paddingRight: '0px',
        paddingBottom: '0',
        transform: 'translate(-50%, -50%)',
      },
    };

    const onPressTryForFree = () => {
      this.setLoader();
      const params = {
        id: this.props.saProfileID,
        trialType: 'free_trial_1',
      };
      startTrial(params)
      .then((res, err) => {
        if (!err) {
          this.setLoader();
          window.location.reload();
          // console.log(res);
        } else {
          this.setLoader();
          window.location.reload();
          // console.log(err);
        }
      });
    };
    const renderLoader = renderIf(isLoading);
    return (
      <div>
        {renderLoader(
          <FullScreenLoader />,
        )}
        <Modal style={modalStyle} isOpen={this.props.show} >
          <div className={cn('row', styles.counter_container)}>
            <button className={styles.absoluteCross} onClick={this.onCloseModal}>
              x
            </button>
            <div className={cn('col s12', styles.header)} >
              LIMIT EXCEEDED
            </div>
            <div className={styles.tutorialData}>
              <div className={styles.containerBox}>
                <div className={styles.imageContainer}>
                  <img alt="filter icon" src="https://s3.amazonaws.com/myrbmedia-dev/Images/loadmore.png" className={styles.filterImage} />
                </div>
                <div className={styles.filterDescription}>
                    You have reached the contact limit of {this.props.showCountOne ? '1' : '10'} college(s) for the day.
                    We are actively communicating with the coaches.
                    Check back after 24hrs to contact more colleges.
                    {(!this.props.subscribed && this.props.onTrial) ? <span style={{ color: '#ef4136' }}> You are currently on a free trial.</span> : ''}
                  {this.props.showCountOne ? <span style={{ color: '#ef4136' }}> You are currently using a free account.</span> : ''}
                </div>
              </div>
            </div>
            {this.props.subscribed ? (<div className={styles.counter_button_container}>
              <button onClick={this.onCloseModal}>Close</button> </div>) : (
                <div className={styles.counter_button_container}>
                  <Link to="/pricing">
                    <button >
                    UPGRADE NOW
                  </button>
                  </Link>
                  {this.props.showTrialButton ? <button className={styles.tryButton} onClick={onPressTryForFree}>
                 TRY FOR FREE
            </button> : ''}
                </div>
               )
            }
          </div>
        </Modal>
      </div>
    );
  }
}


export default Tutorials;



// WEBPACK FOOTER //
// ./src/components/DashboardView/Tutorial/Counter.js